<template>
  <div class="big">
    <div class="page_title">药品"十八反十九畏"设置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>通用名</span>
            <el-input
              v-model="generic_name"
              placeholder="请输入"
              style="width: 160px; margin: 0 12px 0 5px"
              @input="search"
              clearable
            ></el-input>
            <el-button
              type="info"
              size="medium"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-right: 20px;
              "
              @click="search"
            >查询</el-button>
          </div>
          <div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="addDialog"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('542') : false
              "
            >新增配伍禁忌</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="配伍禁忌"
              prop="full_pname"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.generic_name_one }},{{
                    scope.row.generic_name_two
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.taboo_type == 1">十八反</span>
                <span v-if="scope.row.taboo_type == 2">十九畏</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="editDialog(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('542')
                      : false
                  "
                >编辑</el-button>
                <el-button
                  type="text"
                  @click="deltaboo(scope.row.taboo_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('543')
                      : false
                  "
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="addtaboo"
      width="340px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 0; text-align: left">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="配伍1"
            prop="generic_name_one"
          >
            <el-select
              v-model="ruleForm.generic_name_one"
              filterable
              remote
              reserve-keyword
              placeholder="药品通用名"
              :remote-method="getDrugsList"
              :loading="loading"
              style="width: 240px"
              value-key="generic_name"
              @focus="judeMedicine"
              @change="changeName"
            >
              <el-option
                v-for="drugs in drugs_id_list"
                :key="drugs.drug_id"
                :label="drugs.generic_name"
                :value="drugs.generic_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="配伍2"
            prop="generic_name_two"
          >
            <el-select
              v-model="ruleForm.generic_name_two"
              filterable
              remote
              reserve-keyword
              placeholder="药品通用名"
              :remote-method="getDrugsList"
              :loading="loading"
              style="width: 240px"
              value-key="generic_name"
              @focus="judeMedicine"
              @change="changeName"
            >
              <el-option
                v-for="drugs in drugs_id_list"
                :key="drugs.drug_id"
                :label="drugs.generic_name"
                :value="drugs.generic_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="类型"
            prop="taboo_type"
            :required="true"
          >
            <el-radio-group v-model="ruleForm.taboo_type">
              <el-radio :label="1">十八反</el-radio>
              <el-radio :label="2">十九畏</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div style="text-align: center">
          <span
            slot="footer"
            class="dialog-footer"
          >
            <el-button
              type="primary"
              @click="submit('ruleForm')"
              size="medium"
            >保 存</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      loading: false,
      generic_name: '',
      drugs_id_list: [],
      addtaboo: false,
      title: '新增配伍禁忌',
      ruleForm: {
        generic_name_one: '',
        generic_name_two: '',
        taboo_type: 1
      },
      rules: {
        generic_name_one: [
          {
            required: true,
            message: '请输入药品通用名',
            trigger: 'blur'
          }
        ],
        generic_name_two: [
          {
            required: true,
            message: '请输入药品通用名',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        generic_name: this.generic_name
      };
      this.axios
        .post('platform/template/getDrugForbidenList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //新增编辑弹窗
    addDialog() {
      this.ruleForm = {
        generic_name_one: '',
        generic_name_two: '',
        taboo_type: 1
      };
      this.title = '新增配伍禁忌';
      this.addtaboo = true;
    },
    //编辑弹窗
    editDialog(row) {
      this.ruleForm = {
        generic_name_one: row.generic_name_one,
        generic_name_two: row.generic_name_two,
        taboo_type: row.taboo_type,
        taboo_id: row.taboo_id
      };
      this.title = '编辑配伍禁忌';
      this.addtaboo = true;
    },

    //获取药品名称列表
    getDrugsList(query) {
      this.drugs_id_list = [];
      let simple_pname = query;
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.axios
            .post('platform/template/getSystemDrugTcmList', { simple_pname })
            .then((res) => {
              if (res.code == 0) {
                this.drugs_id_list = res.data.list;
              } else {
                this.drugs_id_list = [];
              }
            });
        }, 100);
      } else {
        this.drugs_id_list = [];
      }
    },
    judeMedicine() {
      this.drugs_id_list = [];
    },
    changeName() {
      if (this.ruleForm.generic_name_one == this.ruleForm.generic_name_two) {
        this.$message.error('药品名称不可重复！');
        return false;
      }
    },
    //添加/编辑
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        let data = this.ruleForm;
        if (valid) {
          if (data.generic_name_one == data.generic_name_two) {
            this.$message.error('药品名称不可重复！');
            return false;
          }
          this.axios
            .post('platform/template/saveDrugForbidenInfo', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('保存成功');
                this.addtaboo = false;
                this.getList();
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //删除
    deltaboo(taboo_id) {
      this.$confirm('是否确认删除配伍禁忌？', '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/template/deleteDrugForbidenInfo', { taboo_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('已删除');
                this.getList();
              }
            });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>
